import { FC } from 'react'

import styled from 'styled-components'

import CheckMarkIcon from 'src/Assets/Svg/pages-icons/CheckMark.svg?react'

type Props = {
  countries: string[]
  show?: boolean
  editable?: boolean
  onCountryClick?: (country: string) => void
}
const Container = styled.div`
  display: flex;
  padding-bottom: 8px;
  align-items: flex-start;
  align-content: flex-start;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
`

const Item = styled.div<{ $isSelected?: boolean }>`
  display: flex;
  padding: 9.5px 12px;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme, $isSelected }) =>
    $isSelected ? theme.color.darkGreen : 'transparent'};
  background: ${({ theme }) => theme.color.lightGreen};
  color: ${({ theme }) => theme.color.darkGreen};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  cursor: pointer;
`

export const SelectedCountriesList: FC<Props> = (props) => {
  const { countries, show, editable, onCountryClick } = props

  if (!show) {
    return null
  }

  const handleCountryClick = (
    e: React.MouseEvent<HTMLDivElement>,
    country: string,
  ): void => {
    e.stopPropagation()
    onCountryClick?.(country)
  }

  return (
    <Container>
      {countries.map((country) => (
        <Item
          $isSelected={editable}
          key={country}
          onClick={(e) => handleCountryClick(e, country)}
        >
          {country}
          {editable && <CheckMarkIcon width={16} height={16} />}
        </Item>
      ))}
    </Container>
  )
}
